// import PinyinComponent from './Pinyin.vue';

// const Pinyin = {};

// // 注册Pinyin
// Pinyin.install = function (Vue) {
//     // 生成一个Vue的子类
//     // 同时这个子类也就是组件
//     const PinyinConstructor = Vue.extend(PinyinComponent);
//     // 生成一个该子类的实例
//     const instance = new PinyinConstructor();

//     // 将这个实例挂载在我创建的div上
//     // 并将此div加入全局挂载点内部
//     instance.$mount(document.createElement('div'));
//     document.body.appendChild(instance.$el);

//     // 通过Vue的原型注册一个方法
//     // 让所有实例共享这个方法
//     Vue.prototype.$choicePinyin = (str, callback, type) => {
//         instance.choicePinyin(str, callback, type);
//     };
// };

// export default Pinyin;

import han2PinYin from './Pinyin.vue';

const components = [
    han2PinYin,
];
const install = function (Vue) {
    components.forEach(component => {
        Vue.component(component.name, component);
    });
};

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default han2PinYin
